namespace Pages.Test._Controls.Permission {
    export async function __cdn_pages_test_controls_vehicleusersettings_onDocumentReadyAsync() {
        let main = document.querySelector('main');

        let login = new CDN.Controls.Login(main, {
            onLogin: (result) => {
                login.hide();

                let vehicleSearchInput = new CDN.Controls.UI.TextInput(main, {
                    label: 'Vehicle',
                    placeholder: 'Registration',
                    autocomplete: {
                        minLength: 2,
                        searchAsync: async (term, cancellationToken) => {
                            let vehicles: CDN.API.AutoComplete.v1.Vehicle[] = await CDN.API.AutoComplete.v1.searchAllVehiclesAsync({
                                productId: CDN.Common.ProductId.ERP,
                                userToken: result.UserToken,
                            }, term, cancellationToken);

                            return vehicles
                                .map(v => {
                                    return {
                                        label: v.Registration,
                                        value: v.Registration,
                                        data: v,
                                    };
                                });
                        },
						onSelect: async (vehicle: CDN.API.AutoComplete.v1.Vehicle) => {
                            await vehicleusersettingsManager.setVehicleAsync(vehicle.Registration);
                        },
                    },
                });

                let vehicleusersettingsManager = new CDN.Controls.Permission.VehicleUserSettingsManager(main, {
                    userToken: result.UserToken,
                    userFields: {
                        headings: () => ["Username", "FullName", "CellNumber"],
                        format: vu => [`<a href='#'>${vu.User.UserName}`, vu.User.FullName, vu.User.CellphoneNumber],
                    },
                });
            }
        });

    }
}

CDN.requireOnce([
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.Control_Permission_User, },
    { code: CDN.PackageCode.Control_Collection, },
    { code: CDN.PackageCode.Control_Login, },
], () => {
    $(document).ready(Pages.Test._Controls.Permission.__cdn_pages_test_controls_vehicleusersettings_onDocumentReadyAsync);
});
